import { useSelector } from "react-redux";
import { isDevOrSuperAdmin } from "./isDevOrSuperAdmin";

/** React hook — reads `session.currentUser` from Redux. */
export function useIsDevOrSuperAdmin() {
  const currentUser = useSelector((state) => state.session?.currentUser);
  return isDevOrSuperAdmin(currentUser);
}
